import request from './request';
import api from './api';

// 获取通用配置
// export const getCommonConfig = (params: any) => request.get(api.common_config, { params });
// 表格列相关配置
export const getTableColumnConfig = (params: any) => request.get(api.table_column_config, { params });
// 微应用配置
// export const getMicroAppConfig = (params: any) => request.get(api.micro_app_config, { params });
// 获取FormRender配置
export const getFormRenderConfig = (params: any) => request.get(api.form_render, { params });
// 获取任务系统FormRender配置
export const getTaskFormRenderConfig = (params: any) => request.get(api.task_form_render, { params });

export const indicatorBlacklist = (params: any) => request.get(api.indicator_blacklist, { params });
export const indicatorWhitelist = (params: any) => request.get(api.indicator_whitelist, { params });
